import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Page } from "../models/pages/page";
import { PagesService } from "./pages.service";

@Injectable()
export class ConfigResolve implements Resolve<Page> {

  constructor(
    private _pagesService: PagesService
  ) {}
 
  resolve(route: ActivatedRouteSnapshot) {
    return this._pagesService.getConfig<Page>();
  }
}